import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { UpdateDevEnvDialogData } from './update-devenv-dialog.data';

@Component({
    selector : 'update-devenv-dialog',
    template: require('./update-devenv-dialog.component.html'),
    styles: [require('./update-devenv-dialog.component.scss')]
})
export class UpdateDevEnvDialogComponent {
    objectKeys = Object.keys;

    constructor(@Inject(MAT_DIALOG_DATA) public data: UpdateDevEnvDialogData) {      
        data.selectedAction = data.actions.ByPackage ? data.actions.ByPackage : ""
        data.baselineSelected = data.baselines && data.baselines.length>0 ? data.baselines[0] : null
        data.selected = data.byactions &&  data.byactions.length && data.byactions[0].id? data.byactions[0].id : 0
    }

    changeListByAction(selectedAction:any){
         if(selectedAction==this.data.actions.ByPackage){
            this.data.byactions = this.data.packages
            this.data.selected = this.data.packages[0].id
        }
        else{
            this.data.byactions =  this.data.labels
            this.data.selected = this.data.labels[0].id  
        }  
    }
    
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/update-devenv-dialog/update-devenv-dialog.component.ts